import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductModel } from '../models/product.model';
import { MathService } from '../services/math/math.service';

@Pipe({ name: 'productPrice',pure:false })
export class ProductPricePipe implements PipeTransform {
  constructor(private mathService: MathService, private translateService:TranslateService, private currencyPipe:CurrencyPipe){

  }
  transform(product:ProductModel, priceMode, metricOrigin, countryCode, status?,displayMode?) {
    let display:string = '';
    if(!displayMode || displayMode === 'priceOnly'){
      if(status == 'fixed') { display +='';}
      else if (product.basket?.amountStatus  == 'estimated' || status == 'estimated'){
        display += '±';}
  
      const price = (priceMode === 'VATIncluded' || !priceMode) ? product.details.unitPriceVATIncluded : 
        (product.details.unitPriceVATExcluded || this.mathService.calculateProductVATExcludedPrice(product, countryCode));
      if(priceMode === 'VATExcluded' && !product.details.unitPriceVATExcluded) product.details.unitPriceVATExcluded = price;
  
      display += this.currencyPipe.transform(price,product.details.currency.toUpperCase());
  
    }
    if(!displayMode || displayMode === 'detailsOnly'){
      display += priceMode === 'VATExcluded' ? (' '+this.translateService.instant('tax.VATExcludedShort')): '';

      if(metricOrigin && metricOrigin !== 'none'){
        const metric = metricOrigin === 'price' && product.details.unitPriceQuantityMetricType !== 'piece' ? product.details.unitPriceQuantityMetric : product.details.quantityMetric
        display += ' / ';
        display += this.translateService.instant('quantityMetric.short.'+metric);      
      }      
    }

    return  display;
  }
}